// extracted by mini-css-extract-plugin
module.exports = {"paddedContent":"📦AssetDetail__paddedContent--1MsP8","row":"📦AssetDetail__row--rbDni"};